import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { DataState } from '@/types/data.type';
import { Reel } from '@/types/reel.type';

import { FlowMapItem, LibrarySliceState } from './library.type';

const libraryInitialState: LibrarySliceState = {
    flowMap: {},
    reelMap: {},
    reelStateMap: {},
};

export const LIBRARY_REDUCER_NAME = 'library';

export const librarySlice = createSlice({
    name: LIBRARY_REDUCER_NAME,
    initialState: libraryInitialState,
    reducers: {
        setFlowsByReelCode: (
            state,
            action: PayloadAction<{
                reelCode: string;
                flows: FlowMapItem[];
            }>,
        ) => {
            state.flowMap[action.payload.reelCode] = action.payload.flows;
        },
        setReelByCode: (
            state,
            action: PayloadAction<{
                reelCode: string;
                reel: Reel;
            }>,
        ) => {
            state.reelMap[action.payload.reelCode] = action.payload.reel;
        },
        setReelState: (
            state,
            action: PayloadAction<{
                reelCode: string;
                state: DataState;
            }>,
        ) => {
            state.reelStateMap[action.payload.reelCode] = action.payload.state;
        },
    },
});

export const { setFlowsByReelCode, setReelByCode, setReelState } =
    librarySlice.actions;

export const libraryReducer = librarySlice.reducer;
